import { createSelector } from 'reselect'
import { compareDesc, isSameDay } from 'date-fns'
import { IStore } from '../index'
import { getRooms } from '../bookingCalendar/selectors/erhaltenZimmer'
import { RoomServiceType } from '../../models/Room'

export const getTaskDate = (state: IStore) => state.tasks.date
export const getTaskStarting = (state: IStore) => state.tasks.starting
export const getTaskEnding = (state: IStore) => state.tasks.ending
export const getTaskCleaning = (state: IStore) => state.tasks.cleaning
export const getTaskFeeding = (state: IStore) => state.tasks.feeding
export const getTaskNoPayment = (state: IStore) =>
  state.tasks.noPayment.sort((a, b) => compareDesc(b.startDate, a.startDate))
export const getTaskLoading = (state: IStore) => state.tasks.loading

export const getTaskStartingNew = createSelector(
  [getTaskStarting],
  task => task.filter(t => t.registration !== '1'),
)
export const getTaskStartingDone = createSelector(
  [getTaskStarting],
  task => task.filter(t => t.registration === '1'),
)

export const getTaskEndingNew = createSelector(
  [getTaskEnding],
  task => {
    return task.filter(t => t.registration !== '2')
  },
)
export const getTaskEndingDone = createSelector(
  [getTaskEnding],
  task => task.filter(t => t.registration === '2'),
)

export const getTaskCleaningNew = createSelector(
  [getTaskCleaning, getRooms, getTaskDate],
  (task, rooms, date) =>
    task.filter(t =>
      rooms.find(
        r =>
          String(r.id) === String(t.roomId) &&
          (r.serviceCleaningStage !== RoomServiceType.Cleaned ||
            ((!isSameDay(r.serviceBedding, date) && t['bedding']) ||
              (!isSameDay(r.serviceCleaning, date) && t['cleaning']) ||
              (!isSameDay(r.serviceTowels, date) && t['towels']))),
      ),
    ),
)
export const getTaskCleaningDone = createSelector(
  [getTaskCleaning, getRooms, getTaskDate],
  (task, rooms, date) =>
    task.filter(t =>
      rooms.find(
        r =>
          String(r.id) === String(t.roomId) &&
          (r.serviceCleaningStage === RoomServiceType.Cleaned &&
            ((isSameDay(r.serviceBedding, date) && t['bedding']) ||
              (isSameDay(r.serviceCleaning, date) && t['cleaning']) ||
              (isSameDay(r.serviceTowels, date) && t['towels']))),
      ),
    ),
)

export const getTaskBadge = createSelector(
  [getTaskStartingNew, getTaskEndingNew, getTaskCleaningNew],
  (s, e, c) => s.length + e.length + c.length,
)
